import { parseJson } from "../parsers/jsonParser";
import { parseXml } from "../parsers/xmlParser";
import { parseHtml } from "../parsers/htmlParser";
import { parseForm } from "../parsers/formParser";
import { BodyContentType } from "../constants/restRequestConstants";
import { flattenObject } from "./flattenUtils";


export function parseAndProcessResponse(response, options = { flatten: false }) {

	const result = [];

	// Add headers with the format: headers["headerName"]
	if (response.headers && Object.keys(response.headers).length > 0) {
		Object.entries(response.headers).forEach(([key, value]) => {
			result.push({
				path: `headers["${key}"]`,
				value: value,
				type: typeof value,
			});
		});
	}

	// Add cookies with the format: cookies["cookieName"].property
	if (response.cookies && response.cookies.length > 0) {
		response.cookies.forEach((cookie) => {
			// Add main value path
			result.push({
				path: `cookies["${cookie.name}"].value`,
				value: cookie.value,
				type: 'string',
			});

			if (cookie.domain) {
				result.push({
					path: `cookies["${cookie.name}"].domain`,
					value: cookie.domain,
					type: 'string',
				});
			}

			if (cookie.path) {
				result.push({
					path: `cookies["${cookie.name}"].path`,
					value: cookie.path,
					type: 'string',
				});
			}

			if (cookie.expires) {
				result.push({
					path: `cookies["${cookie.name}"].expires`,
					value: cookie.expires,
					type: 'string',
				});
			}

			if (cookie.httpOnly !== undefined) {
				result.push({
					path: `cookies["${cookie.name}"].httpOnly`,
					value: cookie.httpOnly,
					type: 'boolean',
				});
			}

			if (cookie.secure !== undefined) {
				result.push({
					path: `cookies["${cookie.name}"].secure`,
					value: cookie.secure,
					type: 'boolean',
				});
			}

			if (cookie.sameSite) {
				result.push({
					path: `cookies["${cookie.name}"].sameSite`,
					value: cookie.sameSite,
					type: 'string',
				});
			}
		});
	}


	if (response.isBinary) {
		result.push({
			path: '$',
			value: '[File]',
			type: 'file',
			meta: {
				binary: true,
				size: response.size,
				filename: response.filename,
				fileExtension: response.fileExtension,
				contentType: response.contentType,
			}
		});

		return result;
	}

	const parsed = parseByContentType(response.data, response.contentType);

	// Add body data
	if (options.flatten) {
		const flattenedBody = flattenObject(parsed);
		result.push(...flattenedBody.map(item => ({
			...item,
		})));
	} else {
		result.push({
			path: "$",
			value: parsed,
			type: typeof parsed,
		});
	}

	return result;
}

export function parseByContentType(data, contentType = "") {

	if (contentType.includes(BodyContentType.JSON)) {
		return parseJson(data);
	}
	if (contentType.includes(BodyContentType.XML)) {
		return parseXml(data);
	}
	if (contentType.includes(BodyContentType.HTML)) {
		return parseHtml(data);
	}
	if (contentType.includes(BodyContentType.FORM)) {
		return parseForm(data);
	}
	return data;
}
